import React, { useState } from 'react';
import { Outlet, NavLink, Link, useNavigate } from 'react-router-dom';
import { clearAuth } from '../../utils/authToken';
import './AdminLayout.css';

function AdminLayout() {
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const handleLogoutClick = () => setLogoutModalOpen(true);

  const handleLogoutConfirm = () => {
    clearAuth();
    setLogoutModalOpen(false);
    navigate('/admin/signin', { replace: true });
  };

  const handleLogoutCancel = () => setLogoutModalOpen(false);

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <Link to="/admin/programs">Admin</Link>
        </div>
        <nav className="admin-sidebar-nav" aria-label="Admin navigation">
          <NavLink to="/admin/programs" className={({ isActive }) => (isActive ? 'active' : '')}>
            Programs
          </NavLink>
          <NavLink to="/admin/inquiries" className={({ isActive }) => (isActive ? 'active' : '')}>
            Inquiries
          </NavLink>
          <NavLink to="/admin/bookings" className={({ isActive }) => (isActive ? 'active' : '')}>
            Bookings
          </NavLink>
          {/* <NavLink to="/admin/contacts" className={({ isActive }) => (isActive ? 'active' : '')}>
            Contacts
          </NavLink> */}
          <NavLink to="/admin/testimonials" className={({ isActive }) => (isActive ? 'active' : '')}>
            Testimonials
          </NavLink>
          <NavLink to="/admin/galleries" className={({ isActive }) => (isActive ? 'active' : '')}>
            Galleries
          </NavLink>
          <NavLink to="/admin/announcements" className={({ isActive }) => (isActive ? 'active' : '')}>
            Announcements
          </NavLink>
          <NavLink to="/admin/events" className={({ isActive }) => (isActive ? 'active' : '')}>
            Events
          </NavLink>
          <NavLink to="/admin/scheduled-closings" className={({ isActive }) => (isActive ? 'active' : '')}>
            Scheduled closings
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <button type="button" className="admin-sidebar-logout" onClick={handleLogoutClick}>
            Log out
          </button>
        </div>
      </aside>
      <div className="admin-body">
        <header className="admin-header">
          <h1 className="admin-header-title">David Foster Academy</h1>
          <div className="admin-header-actions">
            <Link to="/" className="admin-header-link">View site</Link>
          </div>
        </header>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>

      {logoutModalOpen && (
        <div className="admin-logout-modal" role="dialog" aria-modal="true" aria-labelledby="logout-modal-title">
          <div className="admin-logout-modal-backdrop" onClick={handleLogoutCancel} aria-hidden="true" />
          <div className="admin-logout-modal-box">
            <h3 id="logout-modal-title">Log out?</h3>
            <p>Are you sure you want to log out?</p>
            <div className="admin-logout-modal-actions">
              <button type="button" className="admin-logout-modal-cancel" onClick={handleLogoutCancel}>
                Cancel
              </button>
              <button type="button" className="admin-logout-modal-confirm" onClick={handleLogoutConfirm}>
                Log out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminLayout;
